module.exports = require('./helpers/bundle-url').getBundleURL('cWze5') + "logo.c51670a8.svg";